import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";
import ThumbUpRoundedIcon from "@mui/icons-material/ThumbUpRounded";
import ThumbDownRoundedIcon from "@mui/icons-material/ThumbDownRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import { BurnAssessment } from "./BurnAssessment";

export const resolveBurnAssessmentIcon = (
  value: BurnAssessment
): OverridableComponent<SvgIconTypeMap> => {
  switch (value) {
    case BurnAssessment.Good:
      return StarRoundedIcon;
    case BurnAssessment.Normal:
      return ThumbUpRoundedIcon;
    case BurnAssessment.Bad:
      return ThumbDownRoundedIcon;
    case BurnAssessment.Unknown:
      return HelpRoundedIcon;
    default:
      return HelpRoundedIcon;
  }
};
